import React, { Component } from "react"
import { Grid, Button } from "semantic-ui-react"
import { Link, Redirect } from "react-router-dom"
import { Prompt, AskForConfirmation } from "uikit"

export class Footer extends Component {
  state = {
    noPrompt: false,
    showConfirmation: false,
    deleteSucceeded: false
  }
  handleDelete = async () => {
    this.setState({
      noPrompt: true
    })
    this.setState(
      {
        showConfirmation: false,
        deleteSucceeded: true
      },
      this.props.onDelete
    )
  }

  render = () => {
    const {
      isNew,
      submitLabel,
      onSubmit,
      isModified,
      deleteLabel,
      hasConnectionId
    } = this.props
    if (this.state.deleteSucceeded) {
      return <Redirect to="/organize/accounts+property" />
    }

    return (
      <>
        {!!this.props.error ? (
          <Grid.Row style={{ background: "red", color: "white" }}>
            <Grid.Column textAlign="center">{this.props.error}</Grid.Column>
          </Grid.Row>
        ) : null}
        <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            {isNew ? (
              <Link to="/organize/accounts+property">
                <Button basic content="Cancel" type="button" color="blue" />
              </Link>
            ) : (
              <Button
                basic
                type="button"
                color="red"
                onClick={() => this.setState({ showConfirmation: true })}
              >
                {deleteLabel}
              </Button>
            )}
            {this.state.showConfirmation ? (
              <AskForConfirmation
                onYes={this.handleDelete}
                onNo={() => this.setState({ showConfirmation: false })}
                header="Are You Sure?"
                render={() => {
                  if (hasConnectionId) {
                    return (
                      <span>
                        If you proceed, you will unlink this account and lose
                        all edits you have made to the original information.
                      </span>
                    )
                  } else {
                    return (
                      <span>
                        If you proceed, you will permanently remove this
                        account.
                        <strong> You cannot undo this action.</strong>
                      </span>
                    )
                  }
                }}
              />
            ) : null}
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button
              content={submitLabel}
              onClick={onSubmit}
              primary
              type="button"
              data-testid="submit"
            />
            {this.state.noPrompt === false ? (
              <Prompt when={isModified} />
            ) : null}
          </Grid.Column>
        </Grid.Row>
      </>
    )
  }
}

Footer.defaultProps = {
  deleteLabel: "Delete",
  submitLabel: "Yes"
}
